<template>
  <v-card v-if='showStatus' class='sync-status'>
    <v-card-text>
      <v-row align='center'>
        <v-col cols='auto'>
          <v-progress-circular
            v-if='syncInProgress'
            indeterminate
            size='20'
            width='2'
          />
          <v-icon v-else :color='statusColor'>
            {{ statusIcon }}
          </v-icon>
        </v-col>
        <v-col>
          <div>{{ statusText }}</div>
          <div v-if='stats.pending > 0' class='text-caption'>
            {{ stats.pending }} verzoeken wachten op synchronisatie
          </div>
        </v-col>
        <v-col cols='auto' v-if='canSync'>
          <v-btn small @click='forceSyncNow'> Sync Nu </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { EventBus } from '@/utils/eventBus'
import axiosOfflineInterceptor from '@/utils/axiosOfflineInterceptor'

export default {
  name: 'SyncStatus',
  data () {
    return {
      showStatus: false,
      syncInProgress: false,
      stats: { pending: 0, failed: 0, synced: 0 },
      isOnline: true
    }
  },
  computed: {
    statusColor () {
      if (!this.isOnline) return 'warning'
      if (this.stats.pending > 0) return 'info'
      return 'success'
    },
    statusIcon () {
      if (!this.isOnline) return 'mdi-wifi-off'
      if (this.stats.pending > 0) return 'mdi-clock-outline'
      return 'mdi-check-circle'
    },
    statusText () {
      if (this.syncInProgress) return 'Synchroniseren...'
      if (!this.isOnline) return 'Offline modus'
      if (this.stats.pending > 0) return 'Wacht op synchronisatie'
      return 'Alles gesynchroniseerd'
    },
    canSync () {
      return this.isOnline && this.stats.pending > 0 && !this.syncInProgress
    }
  },
  async mounted () {
    await this.updateStatus()

    EventBus.$on('sync-started', () => {
      this.syncInProgress = true
    })

    EventBus.$on('sync-completed', async () => {
      this.syncInProgress = false
      await this.updateStatus()
    })

    EventBus.$on('network-status-changed', async (online) => {
      this.isOnline = online
      await this.updateStatus()
    })
  },
  methods: {
    async updateStatus () {
      const status = await axiosOfflineInterceptor.getSyncStatus()
      this.stats = status
      this.isOnline = status.isOnline
      this.showStatus = status.pending > 0 || !status.isOnline
    },
    async forceSyncNow () {
      try {
        await axiosOfflineInterceptor.forceSyncNow()
      } catch (error) {
        console.error('Sync failed:', error)
      }
    }
  }
}
</script>

<style scoped>
.sync-status {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  max-width: 400px;
}
</style>
